import axios from 'axios';
import React, { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaLock } from 'react-icons/fa';
import logo from './images/bestBasketLogo.jpg';

function AdminLoginPage() {
    const [userData, setUserData] = useState({});
    const [loading, setLoading] = useState(false);
    const [userFocused, setUserFocused] = useState(false);
    const [passFocused, setPassFocused] = useState(false);

    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;

    const handleChange = (e) => {
        setUserData({
            ...userData,
            [e.target.name]: e.target.value
        });
    };

    const handleAdminLogin = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${apiUrl}/admin-login`, userData);
            if (response.status === 200) {
                localStorage.setItem('authToken', response.data.token);
                alert('Login successful');
                navigate('/admin');
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                alert(error.response.data.message);
            } else {
                console.error('Error logging in:', error);
                alert('Something went wrong. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <div className="web-login-wrapper">
                <div className="web-login-box">
                    {/* Left Panel: Yellow Brand Header */}
                    <div className="web-login-left">
                        <div className="web-login-logo-container">
                            <img src={logo} alt="Best Basket Logo" className="web-login-logo" />
                        </div>
                        <p className="web-login-left-subtitle">
                            Admin Control Center. Manage products, categories, users, and track order deliveries.
                        </p>
                    </div>

                    {/* Right Panel: Login Form */}
                    <div className="web-login-right">
                        {/* Inputs Area */}
                        <div className="web-login-inputs-area">
                            <label className="web-login-input-label">Username</label>
                            <div className={`web-login-input-wrapper ${userFocused ? 'web-login-input-wrapper-focused' : ''}`}>
                                <FaUser className="web-login-input-icon" size={14} />
                                <input 
                                    type="text" 
                                    placeholder="Enter username" 
                                    name="username" 
                                    onChange={handleChange}
                                    onFocus={() => setUserFocused(true)}
                                    onBlur={() => setUserFocused(false)}
                                    className="web-login-input"
                                />
                            </div>

                            <label className="web-login-input-label">Password</label>
                            <div className={`web-login-input-wrapper ${passFocused ? 'web-login-input-wrapper-focused' : ''}`}>
                                <FaLock className="web-login-input-icon" size={14} />
                                <input 
                                    type="password" 
                                    placeholder="Enter your password" 
                                    name="password" 
                                    onChange={handleChange}
                                    onFocus={() => setPassFocused(true)}
                                    onBlur={() => setPassFocused(false)}
                                    className="web-login-input"
                                />
                            </div>

                            <button 
                                onClick={handleAdminLogin} 
                                className={`web-login-btn ${(loading || !userData.username || !userData.password) ? 'web-login-btn-disabled' : ''}`}
                                disabled={loading || !userData.username || !userData.password}
                            >
                                {loading ? (
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                ) : (
                                    'LOGIN'
                                )}
                            </button>
                        </div>

                        {/* Footer Disclaimer */}
                        <div className="web-login-footer">
                            <p className="web-login-footer-text">
                                Powered by <a href="https://worldomania.com/" target="_blank" rel="noopener noreferrer" className="web-login-footer-link">Worldomania</a>
                            </p>
                            <p className="web-login-footer-text" style={{ marginTop: '4px' }}>
                                <FaLock size={10} style={{ marginRight: 4, color: '#4caf50' }} />
                                Secured connection. Unauthorized access is strictly prohibited.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default AdminLoginPage;
